import type { Language, OptionType } from "../types/types";
import { useContext, useState } from "react";
import useSWR from "swr";
import { Notifications } from "../components/Notifications/NotificationsContext";
import { useStoreState } from "./util";

export const getLanguageOption = (
  languages: OptionType[],
  languageCode: string
): OptionType<string> | undefined => {
  const data = languages.find((language) => language.value === languageCode);
  let label = data?.label;
  if (languageCode) {
    label = label + " (" + languageCode.toUpperCase() + ")";
  }

  return { label: label ?? "", value: data?.value ?? "" };
};

export const useLanguagesList = (): OptionType<string>[] => {
  const [languages, setLanguages] = useState<OptionType<string>[]>([]);
  const { notifyError } = useContext(Notifications);
  const { storefront_id } = useStoreState();
  useSWR<{ languages: Language[] }>(
    `/v1/storefronts/${storefront_id}/languages`,
    {
      onError: (error) => {
        notifyError("There was an error fetching the languages list.", {
          error,
        });
      },
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      shouldRetryOnError: true,
      onSuccess: (data) => {
        setLanguages(
          data.languages.map((language) => {
            return { value: language.alpha_2, label: language.name };
          })
        );
      },
    }
  );
  return languages;
};
